import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const MainChatScreenIcon = (props: SvgProps) => (
  <Svg
    width={64}
    height={58}
    fill="none"
    {...props}
  >
    <Path
      fill="#C0A46F"
      fillRule="evenodd"
      d="M58.618.152c0 3.01-2.44 5.451-5.45 5.451h-.004.003c3.01 0 5.451 2.441 5.451 5.451h.002c0-2.985 2.399-5.41 5.374-5.45A5.451 5.451 0 0 1 58.62.154V.151h-.002ZM4.44 46.842A3.608 3.608 0 0 1 .833 50.45H.83h.002a3.609 3.609 0 0 1 3.609 3.609h.001a3.609 3.609 0 0 1 3.556-3.609 3.609 3.609 0 0 1-3.556-3.608h-.001Z"
      clipRule="evenodd"
    />
    <Path
      stroke="#C0A46F"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M11.5 19.001a4.333 4.333 0 0 1 4.333-4.333h30.334a4.333 4.333 0 0 1 4.333 4.333v30.334l-9.75-6.5H15.833A4.333 4.333 0 0 1 11.5 38.5v-19.5Z"
    />
  </Svg>
)
export default MainChatScreenIcon
